module.exports = __webpack_public_path__ + "static/fonts/iconfont.39de7b8.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/iconfont.ttf?t=1589351592175
// module id = WR9j
// module chunks = 1